var HlxMenuGroup_1;
import { __decorate } from "tslib";
import { customElement, state } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { html } from 'lit';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { menuGroupStyles } from './menu.styles.js';
import { classMap } from 'lit/directives/class-map.js';
import { createRef, ref } from 'lit-html/directives/ref.js';
import { HlxMenuItem } from './menu-item.js';
import { consume } from '@lit/context';
import { dividersContext, groupLabelsContext } from './menu-context.js';
let HlxMenuGroup = HlxMenuGroup_1 = class HlxMenuGroup extends HelixElement {
    constructor() {
        super(...arguments);
        this.itemContainerSlot = createRef();
        this.labelSlot = createRef();
    }
    render() {
        const hasNextSiblingGroup = this.nextSibling instanceof HlxMenuGroup_1;
        return html `
            <div
                class=${classMap({
            'hlx-menu-group': true,
            'hlx-menu-group-divider': hasNextSiblingGroup,
            'hlx-menu-group-with-item-dividers': this.dividers,
            'hlx-menu-group-no-labels': !this.groupLabelsPresent,
        })}>
                <div
                    id="hlx-group-label"
                    aria-hidden="true"
                    class=${classMap({
            'hlx-menu-group-label': true,
            'hlx-menu-group-label-filled': this.hasLabel(),
        })}>
                    <slot name="label" ${ref(this.labelSlot)}></slot>
                </div>
                <div role="group" aria-labelledby="hlx-group-label" class="hlx-menu-item-container">
                    <slot aria-labelledby="hlx-group-label" ${ref(this.itemContainerSlot)}></slot>
                </div>
            </div>
        `;
    }
    getAssignedItems() {
        if (!this.itemContainerSlot.value) {
            return [];
        }
        return this.itemContainerSlot.value
            .assignedElements()
            .filter((element) => element instanceof HlxMenuItem);
    }
    hasLabel() {
        return !!this.labelSlot.value?.assignedElements().length;
    }
};
HlxMenuGroup.styles = [componentStyles, menuGroupStyles];
__decorate([
    state(),
    consume({ context: dividersContext, subscribe: true })
], HlxMenuGroup.prototype, "dividers", void 0);
__decorate([
    state(),
    consume({ context: groupLabelsContext, subscribe: true })
], HlxMenuGroup.prototype, "groupLabelsPresent", void 0);
HlxMenuGroup = HlxMenuGroup_1 = __decorate([
    customElement('hlx-menu-group')
], HlxMenuGroup);
export { HlxMenuGroup };
//# sourceMappingURL=menu-group.js.map